export const overlayPositionClasses: Record<string, string> = {
  top: "top-4 left-1/2 -translate-x-1/2",
  "top-left": "top-4 left-4",
  "top-right": "top-4 right-4",
  center: "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
  "center-left": "top-1/2 left-4 -translate-y-1/2",
  "center-right": "top-1/2 right-4 -translate-y-1/2",
  bottom: "bottom-4 left-1/2 -translate-x-1/2",
  "bottom-left": "bottom-4 left-4",
  "bottom-right": "bottom-4 right-4",
};
